<template>
  <q-card-section
    v-if="title"
    class="q-px-2x-md q-py-xl flex justify-between items-center"
  >
    <span class="text-lg text-neutral text-weight-medium">
      {{ title }}
    </span>
    <PBtn
      v-if="closable"
      color="primary"
      flat
      dense
      round
      @click="emit('close')"
    >
      <CloseIcon class="icon" />
    </PBtn>
  </q-card-section>
  <q-separator class="fullWidth" />
</template>

<script setup>
import CloseIcon from "assets/icons/close.svg";

const emit = defineEmits(["close"]);

defineProps({
  title: {
    type: String,
    default: "",
  },
  closable: {
    type: Boolean,
    default: true,
  },
});
</script>
